module.exports = __webpack_public_path__ + "static/media/24.37dc588e.jpg";